import React from "react";
import UploadD from "./Components/UploadD";
import upload from "./assets/images/upload.png";
import processing from "./assets/images/processing.png";
import download from "./assets/images/download.png";
import logo from "./assets/images/skyraaconverter.svg";
import { Link, useParams, useLocation } from "react-router-dom";
import "./common.css";
import Footer from "./Components/Footer";
import Mainpage from "./Components/Mainpage";
import  { useEffect, useRef } from "react";

const conversions = [
  {
    id: 1,
    type: "PNG ➝ JPG",
    title: "png-to-jpg",
    convertion_type: "jpg",
    input_format: "png",
    p1: "Converting PNG to JPG is ideal when you want to reduce the image file size for web use, sharing, or storage. PNGs are lossless and support transparency, but this comes at the cost of larger files. JPGs, on the other hand, use lossy compression which greatly reduces size.",
    p2: "This conversion works best when transparency isn’t required. Since JPG doesn’t support transparency, any transparent regions will be filled—often with a white or black background, depending on the software used. This suits photographs or artwork where transparency isn't essential.",
    p3: "JPG is more widely accepted across websites and platforms, particularly social media, blogs, and CMS platforms. It renders efficiently and loads quickly, which benefits SEO and performance on mobile or slower connections.",
    p4: "Also, JPG files offer flexible compression settings, allowing users to find the best balance between quality and file size. This makes them a preferred format for sharing and publishing large batches of images efficiently.",
  },
  {
    id: 2,
    title: "png-to-pdf",
    convertion_type: "pdf",
    input_format: "png",
    type: "PNG ➝ PDF",
    p1: "Converting PNG to PDF allows you to embed an image into a document container. This is commonly used for printing, archiving, or sharing documents such as scanned signatures, forms, and photographs",
    p2: "The PDF format ensures the image remains intact and aligned in a fixed layout. This helps maintain appearance across different devices or printers, especially when consistency in formatting is important.",
    p3: "It also simplifies sharing multiple images—multiple PNGs can be combined into one PDF file, creating a single document for easier upload and transmission.",
    p4: "PDF is a universally accepted format, compatible with nearly every system. Whether you're submitting documents online or saving backups, converting PNGs to PDFs ensures professional, readable output",
  },
  {
    id: 3,
    title: "png-to-svg",
    convertion_type: "svg",
    input_format: "png",
    type: "PNG ➝ SVG",
    p1: "PNG to SVG is a more complex transformation because it changes a raster image (pixels) into a vector format (paths). This is especially useful when you want to scale an image infinitely without losing clarity.",
    p2: "The process involves vector tracing, where the software outlines shapes and colors into editable paths. It's best suited for logos, icons, and simple illustrations—converting detailed photographs this way can be inaccurate or messy",
    p3: "SVG files are ideal for responsive design because they load quickly, scale well, and are editable in vector software like Adobe Illustrator or Figma. This makes them popular in web development and UI design.",
    p4: "However, not all PNGs are good candidates for conversion. Complex gradients or photographic elements don’t translate well into vector paths. For those cases, it's better to use a raster format or recreate the graphic as a true vector.",
  },
  {
    id: 4,
    title: "png-to-jpeg",
    convertion_type: "jpeg",
    input_format: "png",
    type: "PNG ➝ JPEG",
    p1: "PNG to JPEG conversion is similar to PNG to JPG, as JPEG and JPG are functionally identical. The main difference lies in the file extension—.jpeg is used in some systems due to naming conventions or compatibility with older software.",
    p2: "The conversion reduces the size of the image while slightly sacrificing quality. PNGs are great for storing high-quality images with crisp details and transparency, but for general image sharing and storage, JPEGs are more efficient.",
    p3: "JPEGs do not support transparency, so any see-through areas in the PNG will be filled. This is acceptable for standard use cases where the image background doesn’t need to be manipulated post-conversion.",
    p4: "Overall, converting PNG to JPEG makes your images more flexible and lighter for everyday use. It's beneficial for online uploads, emails, and embedding in websites or documents where smaller file sizes improve performance.",
  },
  {
    id: 5,
    title: "png-to-webp",
    convertion_type: "webp",
    input_format: "png",
    type: "PNG ➝ WEBP",
    p1: "PNG to WebP is a smart conversion if you're looking to keep quality while drastically reducing file size. WebP, developed by Google, supports both lossless and lossy compression and is specifically optimized for the web.",
    p2: "Unlike JPG, WebP retains transparency like PNG while still shrinking file size significantly. This makes it a fantastic alternative for UI images, product photos, and icons used on websites or mobile apps.",
    p3: "Smaller file sizes lead to faster page load times, better SEO scores, and improved user experiences—especially on slower internet connections or data-limited mobile devices.",
    p4: "WebP is supported by most modern browsers, though it’s always good to provide a fallback image for full compatibility. It’s the go-to choice for developers aiming to modernize and optimize websites.",
  },
  {
    id: 6,
    title: "png-to-tiff",
    convertion_type: "tiff",
    input_format: "png",
    type: "PNG ➝ TIFF",
    p1: "When converting PNG to TIFF, you're moving to a high-fidelity format used in publishing and archival workflows. TIFF is often used in professional photography, medical imaging, and print production",
    p2: "Unlike WebP or JPG, TIFF supports lossless compression, layers, and metadata. It’s perfect for preserving the image’s highest quality for editing or storage without losing detail.",
    p3: "TIFFs are not web-friendly due to their size and limited browser support, but they excel in environments where accuracy and color depth matter—like book printing or scanning.",
    p4: "This format is ideal when you want to retain full-quality source images for editing, archiving, or printing. If you're preparing materials for long-term storage or commercial printing, this conversion is the right step",
  },
  {
    id: 7,
    title: "png-to-avif",
    convertion_type: "avif",
    input_format: "png",
    type: "PNG ➝ AVIF",
    p1: "AVIF is a modern, highly efficient image format. Converting PNG to AVIF results in drastically smaller file sizes while maintaining quality—especially with high-resolution images.",
    p2: "AVIF supports transparency, like PNG, making it a great replacement for web and mobile content. It's especially beneficial when targeting performance without sacrificing visual appearance.",
    p3: "This format also supports HDR and deep color depth, making it great for photography, app backgrounds, and UI elements. Its ability to compress images better than even WebP is a major strength.",
    p4: "While browser and software support is still growing, AVIF is rapidly becoming a favorite for developers and designers who need sleek, fast-loading visuals with modern capabilities.",
  },
  {
    id: 8,
    title: "png-to-heic",
    convertion_type: "heic",
    input_format: "png",
    type: "PNG ➝ HEIC",
    p1: "When converting PNG to HEIC, you're transitioning to a highly efficient image format designed for modern devices and applications. HEIC (High Efficiency Image Codec) offers advanced compression while retaining excellent image quality, making it perfect for storage-conscious environments.",
    p2: "Unlike PNG, which is widely used for transparency and crisp quality, HEIC significantly reduces file size using advanced compression algorithms without sacrificing detail. This makes it ideal for mobile devices, cloud storage, and fast sharing.",
    p3: "HEIC files are commonly used across iOS and macOS systems, especially in Apple's Photos app. While it’s not universally supported by all platforms yet, HEIC is gaining traction for its efficiency and future-readiness.",
    p4: "Choose this conversion when you want to maintain visual fidelity while reducing file size. It’s especially useful for users who work with high-quality visuals but need to optimize space, such as in mobile photography or app development.",
  },
  {
    id: 9,
    title: "jpg-to-png",
    convertion_type: "png",
    input_format: "jpg",
    type: "JPG ➝ PNG",
    p1: "Converting JPG to PNG is a common step for users wanting to avoid repeated compression loss. While JPG is a lossy format, PNG preserves the image as-is during save operations. So, this conversion is often used in editing workflows where maintaining image quality during revisions is key.",
    p2: " PNG also introduces support for transparency, which JPG lacks. Designers and developers often convert JPG to PNG when they need to remove or modify backgrounds, or incorporate the image into compositions requiring layered transparency",
    p3: "Although PNG files are larger, this tradeoff is acceptable when transparency or quality retention is more important than file size. This makes PNG suitable for logos, digital artwork, UI elements, and application assets.",
    p4: "For app developers and content creators, PNG is the go-to format when there's a need for precision and visual clarity—especially when exporting screenshots, design assets, or preparing visuals for responsive UI environments.",
  },
  {
    id: 10,
    title: "jpg-to-pdf",
    convertion_type: "pdf",
    input_format: "jpg",
    type: "JPG ➝ PDF",
    p1: " Converting a JPG to PDF is one of the most common document conversions. It is often used in  digitizing paperwork, converting scanned forms or images of documents into a format that can be submitted, printed, or stored easily.",
    p2: "This format change ensures that layout and alignment are preserved, making it suitable for official purposes like applications, reports, or certificates. PDF is platform-independent and opens uniformly across devices",
    p3: "Another benefit is bundling—multiple JPGs can be combined into one PDF file, which is particularly useful for creating portfolios, presentations, or eBooks. This reduces the need for image viewers and makes sharing and viewing easier for recipients.",
    p4: " PDFs can also be password-protected or digitally signed, adding a layer of security that image formats lack. This makes the conversion ideal for administrative workflows, digital archiving, and secure sharing.",
  },
  {
    id: 11,
    title: "jpg-to-svg",
    convertion_type: "svg",
    input_format: "jpg",
    type: "JPG ➝ SVG",
    p1: "The JPG to SVG conversion involves a transformation from raster (pixel-based) to vector (path-based) format. This is typically done using vector tracing tools or software that converts visible shapes into scalable lines and curves.",
    p2: " SVGs shine in scalability; once a JPG is converted to SVG, it can be resized to any dimension without pixelation, making it perfect for icons, logos, and simplified graphics. However, detailed photographs don’t convert well and may result in distorted vectors",
    p3: "This conversion is more suitable for stylized graphics, sketches, and flat art rather than real-world imagery. Designers use it to create high-resolution-independent assets that retain their quality across mobile, desktop, and print resolutions.",
    p4: "SVG files are lightweight and editable via code or design software, making them ideal for web environments. They can even include interactive elements or animations, which adds extra usability that raster images don’t offer.",
  },
  {
    id: 12,
    title: "jpg-to-jpeg",
    convertion_type: "jpeg",
    input_format: "jpg",
    type: "JPG ➝ JPEG",
    p1: " Converting JPG to JPEG is essentially a file renaming task, as both formats are technically identical in structure and compression method. The primary difference lies in the file extension, which can sometimes cause issues with older operating systems or specialized software expecting one over the other.",
    p2: " This renaming can be useful in batch-processing pipelines or automation workflows where uniform file extensions reduce the chance of errors. Standardization ensures better compatibility across operating systems, especially when shared across multiple platforms or software types",
    p3: " There’s no actual change in image quality or format behavior with this conversion—it’s purely about extension compatibility. Some users may prefer .jpeg for organizational or naming conventions, especially when preparing files for publishing, uploading, or exporting.",
    p4: "Despite being functionally identical, making the switch helps maintain consistency across an image repository and may prevent unexpected incompatibility warnings during automated uploads or image handling scripts.",
  },
  {
    id: 13,
    title: "jpg-to-webp",
    convertion_type: "webp",
    input_format: "jpg",
    type: "JPG ➝ WEBP",
    p1: " Converting JPG to WebP offers significant file size reduction without a noticeable loss in quality. This makes it ideal for websites and apps that demand fast loading times and minimal bandwidth usage.",
    p2: " WebP supports both lossy and lossless compression, unlike JPG, which is purely lossy. This flexibility lets developers choose the best balance between quality and performance for their specific use case.",
    p3: " In addition, WebP supports transparency (alpha channel), which JPG lacks. This makes it a versatile replacement for both PNG and JPG in modern web development, especially for UI elements, backgrounds, and icons.",
    p4: "The growing adoption of WebP by browsers and CMS platforms makes this conversion a future-proof step in optimizing digital assets. It’s particularly useful in mobile-first design, where speed and bandwidth are critical.",
  },
  {
    id: 14,
    title: "jpg-to-tiff",
    convertion_type: "tiff",
    input_format: "jpg",
    type: "JPG ➝ TIFF",
    p1: " Converting JPG to TIFF is a common practice in professional photography and printing. JPG images, which may have already been compressed, are saved as TIFFs to preserve current quality and enable non-destructive editing.",
    p2: " TIFF supports high bit-depth and multiple color channels, making it ideal for image correction, retouching, and printing workflows. Unlike JPG, TIFF does not compress data in a lossy manner, so future saves do not degrade quality.",
    p3: " This format also supports layers and metadata, making it useful in design software like Photoshop and for industries that rely on archiving image history and editing steps.",
    p4: " TIFFs are large in size, but they’re the preferred format for museum-grade digital scans, medical imaging, and professional media production. They serve as a long-term, high-fidelity format for archival and publishing needs.",
  },
  {
    id: 15,
    title: "jpg-to-avif",
    convertion_type: "avif",
    input_format: "jpg",
    type: "JPG ➝ AVIF",
    p1: "AVIF is one of the most advanced modern formats, offering superior compression and image quality. Converting JPG to AVIF drastically reduces file size while preserving or even enhancing perceptual quality.",
    p2: " It’s especially beneficial for websites and mobile apps where speed and storage efficiency are crucial. The format supports features like HDR, transparency, and wide color gamut—making it more powerful than JPG.",
    p3: "AVIF’s efficient compression is ideal for visual media platforms, ecommerce websites, or any application where high performance and excellent visuals must coexist. It provides better efficiency than WebP and better quality than JPG for the same size.",
    p4: " Though not universally supported yet, AVIF is gaining momentum across modern platforms and browsers. Converting JPGs to AVIF is a smart move for future-proofing media assets and optimizing digital experiences.",
  },
  {
    id: 16,
    title: "jpg-to-heic",
    convertion_type: "heic",
    input_format: "jpg",
    type: "JPG ➝ HEIC",
    p1: "Switching from JPG to HEIC helps modernize your image storage by reducing file size while enhancing visual quality. HEIC’s efficiency is ideal for minimizing storage usage without the quality loss often associated with JPG.",
    p2: "JPG is one of the most common image formats but uses lossy compression that can degrade image clarity. HEIC, on the other hand, uses advanced methods that keep images sharp and clear even after compression.",
    p3: "HEIC is especially beneficial for users on iPhones, iPads, or Macs, as it's fully supported within the Apple ecosystem. Although not all platforms support it natively, many tools now offer compatibility or conversion options",
    p4: "This conversion is recommended when you're optimizing images for modern use, especially in mobile environments. It’s a smart choice for users who want smaller files without compromising on image integrity.",
  },
  {
    id: 17,
    title: "jpeg-to-png",
    convertion_type: "png",
    input_format: "jpeg",
    type: "JPEG ➝ PNG",
    p1: "JPEG to PNG conversion is great when you want to edit the image or preserve its current quality. Since PNG is lossless, you avoid introducing further degradation during saves or edits.",
    p2: "This is helpful in workflows where transparency is needed—something JPEG doesn’t support. For instance, you can make part of an image transparent for overlay purposes after converting to PNG.",
    p3: "Although the file size will increase, PNGs offer better preservation of image detail during multiple edits. This makes it ideal for digital artists and designers.",
    p4: "It’s not meant for reducing size but for preserving fidelity and enabling transparency or layered work in creative projects.",
  },
  {
    id: 18,
    title: "jpeg-to-pdf",
    convertion_type: "pdf",
    input_format: "jpeg",
    type: "JPEG ➝ PDF",
    p1: "This conversion embeds your JPEG into a document format, useful for reports, records, or official submissions. It ensures consistent layout and print readiness.",
    p2: "PDFs are compatible with virtually all devices and operating systems. They're preferred for archiving, printing, and file submission processes in both academic and professional settings.",
    p3: "Converting to PDF also allows bundling multiple JPEGs into one document. This is helpful when compiling photo albums, certificates, or ID proofs into a single file.",
    p4: "It ensures that your visual content remains unaltered during transmission, with no risk of quality loss due to compression or reformatting by external tools.",
  },
  {
    id: 19,
    title: "jpeg-to-svg",
    convertion_type: "svg",
    input_format: "jpeg",
    type: "JPEG ➝ SVG",
    p1: "This conversion vectorizes a raster image, turning it into scalable paths. It's done by tracing the outlines of shapes and colors to create a simplified version of the original image.",
    p2: "It works best on graphics, logos, or illustrations with clear boundaries and few colors. Photographic JPEGs don’t translate well and may appear distorted or over-simplified.",
    p3: "Once converted, SVGs can be scaled indefinitely without loss in quality. They’re editable in vector-based tools and perfect for responsive design.",
    p4: "While the conversion is not perfect for all JPEGs, it offers a way to repurpose image assets for logos, UI icons, or stylized representations on the web.",
  },
  {
    id: 20,
    title: "jpeg-to-jpg",
    convertion_type: "jpg",
    input_format: "jpeg",
    type: "JPEG ➝ JPG",
    p1: "JPEG and JPG are the same format—just different names. JPG was the original Windows-compatible version due to three-letter file extension limits. Nowadays, they are used interchangeably.",
    p2: "This conversion is essentially a renaming, useful for consistency across systems or when adhering to naming standards in automation or CMS platforms.",
    p3: "Some legacy systems, particularly in older content management tools, may accept only one extension. So renaming JPEG to JPG ensures broader compatibility.",
    p4: "There is no quality change, data loss, or visual difference during this conversion. It's simply for organization, consistency, or software requirements.",
  },
  {
    id: 21,
    title: "jpeg-to-webp",
    convertion_type: "webp",
    input_format: "jpeg",
    type: "JPEG ➝ WEBP",
    p1: "JPEG to WebP is excellent for modern web use. WebP provides better compression, reducing the size significantly while retaining visual quality.",
    p2: "This means faster load times, less bandwidth usage, and quicker rendering—especially useful for blogs, eCommerce platforms, and mobile apps.",
    p3: "WebP supports both lossy and lossless compression, along with metadata and animation capabilities. It’s a more flexible format than JPEG for developers.",
    p4: "WebP has become the preferred format for online assets where performance and visual integrity are important. Converting legacy JPEGs to WebP is a smart optimization step.",
  },
  {
    id: 22,
    title: "jpeg-to-tiff",
    convertion_type: "tiff",
    input_format: "jpeg",
    type: "JPEG ➝ TIFF",
    p1: "Converting JPEG to TIFF is ideal when you want to preserve image quality and begin a non-destructive editing workflow. TIFFs support lossless storage.",
    p2: "While JPEGs lose quality with each save, TIFFs retain full resolution and color depth, which is important in photography, design, and scanning tasks.",
    p3: "TIFFs also support layers and alpha channels, allowing for more advanced editing than JPEGs. This makes them perfect for Photoshop workflows and publishing pipelines.",
    p4: "Though larger in size, TIFFs are the preferred choice in industries that prioritize image fidelity over storage efficiency.",
  },
  {
    id: 23,
    title: "jpeg-to-avif",
    convertion_type: "avif",
    input_format: "jpeg",
    type: "JPEG ➝ AVIF",
    p1: "JPEG to AVIF conversion brings modern compression and performance to older image libraries. AVIF produces smaller files without noticeable quality loss.",
    p2: "It also supports advanced features like transparency, HDR, and a wide color gamut, which JPEG lacks. This allows more detailed and flexible image use in web or media environment",
    p3: "AVIF is excellent for responsive and modern websites where performance matters. Images load faster and consume less bandwidth.",
    p4: "As browser and device support for AVIF grows, converting from JPEG can dramatically reduce page weight and enhance the end-user experience.",
  },
  {
    id: 24,
    title: "jpeg-to-heic",
    convertion_type: "heic",
    input_format: "jpeg",
    type: "JPEG ➝ heic",
    p1: "Converting JPEG to HEIC means upgrading to a smarter, space-saving format that offers improved compression. HEIC files are capable of maintaining better image quality at smaller file sizes than traditional JPEGs, thanks to their use of modern coding standards like HEVC.",
    p2: "JPEG is a widely used format, but it uses older compression methods that often lead to visible artifacts, especially after multiple saves. HEIC counters this with better image preservation, making it more suitable for today's high-resolution images.",
    p3: "While HEIC isn't yet supported by all browsers and image editors, it’s natively used in Apple’s ecosystem and is becoming more common in professional workflows. It’s particularly useful for mobile users who need to save space without losing clarity.",
    p4: "This conversion is a great option if you’re working with limited storage or want to prepare your images for use on modern devices. It allows you to retain better image quality in a smaller file footprint.",
  },
];
function Pngtosvg() {
  const { slug } = useParams();
  const lastWord = slug?.split('-').pop();
  
  const { state } = useLocation();
  console.log("state" , state);
  
  const topRef = useRef(null);

  // Scroll to top when the route changes
  useEffect(() => {
    topRef.current.scrollIntoView({ behavior: "smooth" });
  }, [slug]); // Trigger when slug changes

  const conversion =
    state?.conversion ||
    conversions.find((item) => item.title === slug || item.id === Number(slug));

  if (!conversion) {
    return (
      <div className="mx-2 lg:mx-32">
        <h4 className="mt-5 ml-5">Conversion Not Found</h4>
        <p className="text-justify px-8 mt-3">
          The requested conversion type does not exist.
        </p>
      </div>
    );
  }

  return (
    <div ref={topRef}>
           <div className=" mt-8  " style={{ placeItems: "center" }}>
             <Link to="/">
               <div className="w-[9rem] ">
                 <img
                   src={logo}
                   alt="skyraa converter"
                   className="w-[100%] h-[10%]"
                   style={{ cursor: "pointer" }}
                 />
               </div>
             </Link>
             <h1 className="gradient-text text-[27px] md:text-[2.2rem] " style={{ cursor: "pointer"  }}>
               Skyra Convertor
             </h1>
             <p className="px-6 md:px-24  lg:px-32 xl:px-64 text-center">
               We value your privacy. All images you upload are automatically deleted
               from our servers after 30 minutes, ensuring your data stays secure
               while you enjoy a fast, smooth, and hassle-free conversion experience
             </p>
           </div>
           {/* Horizontal Line with Three Colors */}
           <div className="  my-5">
             <div className="flex">
               <div className="flex-1 h-2 bg-red-500"></div>
               <div className="flex-1 h-2 bg-yellow-500"></div>
               <div className="flex-1 h-2 bg-green-500"></div>
             </div>
           

        <div className="px-2 md:px-24  lg:px-32   xl:px-48">
          {/* need to pass the input format and convertion type  to this component  */}
          <UploadD
            io_type={conversion.input_format}
            c_type={lastWord}
          />
        </div>

        <div className="px-2 md:px-24  lg:px-32   xl:px-48">
          <h4 className="mt-5 ml-5">{conversion.type}</h4>
          <p className="text-justify px-8 mt-3 faq-content text-gray-600">{conversion.p1}</p>
          <p className="text-justify px-8 mt-3 faq-content text-gray-600">{conversion.p2}</p>
          <p className="text-justify px-8 mt-3 faq-content text-gray-600">{conversion.p3}</p>
          <p className="text-justify px-8 mt-3 faq-content text-gray-600">{conversion.p4}</p>
        </div>
      </div>

      <div className="text-center my-8">
        <h3>How to Convert Images to any Format ?</h3>
      </div>
      <div className=" mx-2 md:mx-16 lg:mx-32  xl:mx-48 px-4 sm:flex sm:gap-12 sm:justify-center sm:items-center my-10">
        <div className=" justify-items-center my-10 md:my-0">
          <div className="" style={{ width: "130px", height: "130px" }}>
            <img
              src={upload}
              alt="upload images"
              style={{ width: "100%", height: "100%" }}
            />
          </div>
          <h4 className="mt-3">1.Choose Images</h4>
          <p className="text-center faq-content text-gray-600">
            Easily upload your images or Upload them directly into your
            browser. No fuss — just a smooth start to your conversion.
          </p>
        </div>
        <div className="justify-items-center my-10 md:my-0 ">
          <div className="" style={{ width: "130px", height: "130px" }}>
            <img
              src={processing}
              alt="upload images"
              style={{ width: "100%", height: "100%" }}
            />
          </div>
          <h4 className="mt-3 ">2.Start Conversion</h4>
          <p className="text-center faq-content text-gray-600">
            Choose your desired output format and optionally compress your image
            for faster sharing and optimized storage. Quick, easy, and
            high-quality every time.
          </p>
        </div>
        <div className="justify-items-center my-10 md:my-0">
          <div className="" style={{ width: "130px", height: "130px" }}>
            <img
              src={download}
              alt="upload images"
              style={{ width: "100%", height: "100%" }}
            />
          </div>
          <h4 className="mt-3">3.Download Images</h4>
          <p className="text-center faq-content text-gray-600">
            Once the conversion (and optional compression) is complete, simply
            download your high-quality images instantly — quick, clean, and
            hassle-free.
          </p>
        </div>
      </div>

      <Footer />
    </div>
  );
}

export default Pngtosvg;
